import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { updateMetaTags } from '../utils/seo'

const MacBookMuenchenPage: React.FC = () => {
  const navigate = useNavigate()
  const go = (path: string) => { navigate(path); setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50) }

  useEffect(() => {
    updateMetaTags({
      title: 'MacBook Reparatur München – PhoneMedic | ab 119€',
      description: 'MacBook Reparatur München ✓ Platinen-Reparatur ✓ Display ✓ Akku ✓ Wasserschaden ✓ ab 119€ ✓ Bundesweiter Einsende-Service ✓ 12 Monate Garantie | PhoneMedic',
      keywords: ['MacBook Reparatur München', 'MacBook Reparatur München Preise', 'Laptop Reparatur München', 'MacBook startet nicht München', 'Apple Reparatur München', 'iPhone Reparatur München'],
      canonicalUrl: 'https://www.phone-medic.de/macbook-reparatur-muenchen',
    })

    const schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'PhoneMedic – MacBook Reparatur München',
        description: 'MacBook Reparatur für München und bundesweit per Einsende-Service. Spezialist für Platinen-Reparatur, Wasserschäden und Mikrochip-Löten.',
        url: 'https://www.phone-medic.de',
        telephone: '+491605010907',
        email: 'service@phone-medic.de',
        address: {
          '@type': 'PostalAddress',
          streetAddress: 'Wahlenstraße 27',
          postalCode: '93047',
          addressLocality: 'Regensburg',
          addressRegion: 'Bayern',
          addressCountry: 'DE',
        },
        areaServed: [
          { '@type': 'City', name: 'München' },
          { '@type': 'Country', name: 'Germany' },
        ],
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          reviewCount: '32',
          bestRating: '5',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Kann ich mein MacBook aus München einschicken?',
            acceptedAnswer: { '@type': 'Answer', text: 'Ja. Du erhältst ein kostenloses DHL-Versandlabel und kannst dein MacBook bequem aus München einsenden. Die Abgabe bei einer DHL-Filiale in München reicht. Wir reparieren und schicken versichert zurück.' },
          },
          {
            '@type': 'Question',
            name: 'Was kostet MacBook Reparatur für Kunden aus München?',
            acceptedAnswer: { '@type': 'Answer', text: 'Diagnose ab 24,95€, Platinen-Reparatur ab 119€, Display-Tausch ab 229€, Akku-Tausch ab 129€. Alle Preise inklusive 12 Monate Garantie und kostenlosem Rückversand.' },
          },
          {
            '@type': 'Question',
            name: 'Warum kein eigener Laden in München?',
            acceptedAnswer: { '@type': 'Answer', text: 'Wir verzichten bewusst auf ein teures Ladenlokal in München. Das spart Kosten, die wir direkt an unsere Kunden weitergeben. Der Einsende-Service ist schnell, unkompliziert und bundesweit verfügbar.' },
          },
          {
            '@type': 'Question',
            name: 'Wie lange dauert die Reparatur?',
            acceptedAnswer: { '@type': 'Answer', text: 'Standard-Reparaturen (Display, Akku) dauern 2–3 Werktage. Platinen-Reparaturen 3–5 Werktage. Inklusive Versand (hin und zurück) rechne mit 5–8 Werktagen.' },
          },
          {
            '@type': 'Question',
            name: 'Welche MacBook Modelle werden repariert?',
            acceptedAnswer: { '@type': 'Answer', text: 'Alle MacBook Modelle: MacBook Air M1/M2/M3, MacBook Pro 13/14/16 Zoll M1 bis M4, sowie alle Intel MacBooks.' },
          },
        ],
      },
    ]

    let script = document.querySelector('#macbook-muenchen-schema') as HTMLScriptElement
    if (!script) {
      script = document.createElement('script')
      script.id = 'macbook-muenchen-schema'
      script.type = 'application/ld+json'
      document.head.appendChild(script)
    }
    script.textContent = JSON.stringify(schema)
    return () => { document.querySelector('#macbook-muenchen-schema')?.remove() }
  }, [])

  const services = [
    { title: 'Platinen-Reparatur', desc: 'Chip-Level Reparatur für MacBooks die nicht starten, Wasserschäden oder Kurzschlüsse haben.', price: 'ab 119 €', path: '/macbook-startet-nicht' },
    { title: 'Wasserschaden', desc: 'Professionelle Platinen-Reinigung und Reparatur nach Flüssigkeitsschäden. Erfolgsquote 70–90 %.', price: 'ab 119 €', path: '/macbook-wasserschaden' },
    { title: 'Display Reparatur', desc: 'Gesprungenes oder schwarzes Display tauschen. Retina & Liquid Retina XDR alle Modelle.', price: 'ab 229 €', path: '/macbook-display-reparatur' },
    { title: 'Akku Austausch', desc: 'MacBook Air und Pro Akku tauschen. Alle Modelle, original Qualität, schnelle Abwicklung.', price: 'ab 129 €', path: '/macbook-akku-tauschen' },
    { title: 'Tastatur / Topcase', desc: 'Defekte Tasten oder klebende Tastatur? Topcase-Tausch für alle MacBook Generationen.', price: 'ab 129 €', path: '/repair' },
    { title: 'Ladeport / USB-C', desc: 'MacBook lädt nicht? Defekter USB-C Ladeport tauschen – schnell und günstig.', price: 'ab 79 €', path: '/repair' },
  ]

  const faqs = [
    { q: 'Kann ich mein MacBook aus München einschicken?', a: 'Ja. Du erhältst ein kostenloses DHL-Versandlabel und kannst dein MacBook bequem aus München einsenden. Wir bestätigen den Eingang und schicken es nach der Reparatur versichert zurück.' },
    { q: 'Warum kein eigener Laden in München?', a: 'Wir verzichten bewusst auf ein teures Ladenlokal in München. Das spart Kosten, die wir direkt an unsere Kunden weitergeben. Der Einsende-Service ist schnell, unkompliziert und günstiger.' },
    { q: 'Was kostet MacBook Reparatur für Kunden aus München?', a: 'Diagnose ab 24,95€, Platinen-Reparatur ab 119€, Display-Tausch ab 229€, Akku-Tausch ab 129€. Alle Preise inkl. 12 Monate Garantie.' },
    { q: 'Wie lange dauert die Reparatur?', a: 'Standard-Reparaturen 2–3 Werktage, Platinen-Reparaturen 3–5 Werktage. Inklusive Versand ca. 5–8 Werktage.' },
    { q: 'Welche MacBook Modelle werden repariert?', a: 'Alle MacBook Modelle: MacBook Air M1/M2/M3, MacBook Pro 13/14/16 Zoll M1 bis M4, sowie alle Intel MacBooks.' },
    { q: 'Gibt es eine Garantie?', a: '12 Monate Garantie auf alle Reparaturen. Wenn das gleiche Problem innerhalb eines Jahres wieder auftritt, reparieren wir kostenfrei.' },
  ]

  return (
    <div className="min-h-screen bg-white">
      <section
        className="relative text-white py-20"
        style={{ backgroundImage: 'url(/hero-bg.webp)', backgroundSize: 'cover', backgroundPosition: 'center top' }}
      >
        <div className="absolute inset-0 bg-gray-900/80" />
        <div className="relative max-w-7xl mx-auto px-4">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-indigo-600/20 border border-indigo-500/30 text-indigo-300 text-sm font-medium px-3 py-1 rounded-full mb-6">
              <span className="w-1.5 h-1.5 bg-indigo-400 rounded-full"></span>
              München · Bundesweiter Einsende-Service
            </div>
            <h1 className="text-5xl font-bold mb-6 leading-tight">
              MacBook Reparatur München –<br />
              <span className="text-indigo-400">PhoneMedic</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl">
              Professionelle MacBook Reparatur für Kunden aus München und dem gesamten Großraum München. Platinen-Reparatur, Display, Akku – fair bepreist, mit 12 Monaten Garantie.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="mailto:service@phone-medic.de" className="bg-indigo-600 text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-indigo-700 transition-colors">
                Reparatur anfragen
              </a>
              <a href="https://wa.me/491605010907" target="_blank" rel="noopener noreferrer" className="bg-white/10 text-white border border-white/20 px-7 py-3.5 rounded-lg font-semibold hover:bg-white/20 transition-colors">
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-800 text-white py-5 border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            {[
              { number: '4,9 ★', label: '32 Google-Bewertungen' },
              { number: 'ab 119 €', label: 'Platinen-Reparatur' },
              { number: '12 Monate', label: 'Garantie' },
              { number: 'Bundesweit', label: 'Einsende-Service' },
            ].map((s, i) => (
              <div key={i}>
                <div className="text-2xl font-bold text-indigo-400">{s.number}</div>
                <div className="text-sm text-gray-400">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">MacBook Reparatur Services für München</h2>
            <p className="text-gray-500">Alle Reparaturen – Einsende-Service bundesweit</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((s, i) => (
              <div
                key={i}
                className="bg-white rounded-xl border border-gray-200 p-6 flex flex-col hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => go(s.path)}
              >
                <h3 className="font-bold text-gray-900 mb-2">{s.title}</h3>
                <p className="text-sm text-gray-500 flex-1 mb-4">{s.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="font-bold text-indigo-600">{s.price}</span>
                  <span className="text-sm text-indigo-600 font-medium">Mehr →</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Einsende-Service – So funktioniert's</h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                PhoneMedic ist in Bayern ansässig und bietet einen Einsende-Service für ganz Deutschland an. Kunden aus München und dem gesamten Großraum schicken ihr MacBook unkompliziert ein – kostenlos mit DHL, versichert zurück. Kein Stau, keine Parkplatzsuche, keine Wartezeit im Laden.
              </p>
              <ol className="space-y-4">
                {[
                  { step: '1', title: 'Kontakt aufnehmen', desc: 'Per E-Mail oder WhatsApp. Du erhältst sofort ein kostenloses DHL-Versandlabel.' },
                  { step: '2', title: 'MacBook einsenden', desc: 'Sicher verpacken und bei einer DHL-Filiale in München abgeben. Wir bestätigen den Eingang.' },
                  { step: '3', title: 'Diagnose & Angebot', desc: 'Wir analysieren dein MacBook und senden dir einen verbindlichen Kostenvoranschlag.' },
                  { step: '4', title: 'Reparatur & Rücksendung', desc: 'Nach deiner Freigabe reparieren wir es und schicken es versichert zurück nach München.' },
                ].map((item) => (
                  <li key={item.step} className="flex gap-4">
                    <div className="w-10 h-10 bg-gray-900 text-white rounded-full flex items-center justify-center font-bold shrink-0">{item.step}</div>
                    <div>
                      <div className="font-bold text-gray-900">{item.title}</div>
                      <div className="text-sm text-gray-500">{item.desc}</div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
            <div className="bg-gray-50 rounded-xl border border-gray-200 p-6">
              <h3 className="font-bold text-gray-900 mb-4">Kontakt</h3>
              <div className="space-y-3">
                <a href="https://wa.me/491605010907" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  WhatsApp: 0160-5010907
                </a>
                <a href="mailto:service@phone-medic.de" className="flex items-center gap-3 text-gray-600 hover:text-gray-900 transition-colors text-sm">
                  service@phone-medic.de
                </a>
                <div className="text-gray-600 text-sm">
                  Bayern (kein Ladenlokal – bundesweiter Einsende-Service)
                </div>
              </div>
              <div className="mt-6 p-4 bg-indigo-50 border border-indigo-200 rounded-lg">
                <p className="text-sm text-indigo-800">
                  <strong>München & Großraum.</strong> Kunden aus München, Augsburg und dem gesamten Großraum nutzen unseren Einsende-Service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">Häufige Fragen</h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-white border border-gray-200 rounded-xl p-6">
                <h3 className="font-semibold text-gray-900 mb-2">{faq.q}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Weitere MacBook Services</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: 'MacBook startet nicht', path: '/macbook-startet-nicht' },
              { label: 'MacBook Wasserschaden', path: '/macbook-wasserschaden' },
              { label: 'MacBook Display Reparatur', path: '/macbook-display-reparatur' },
              { label: 'Alle MacBook Reparaturen', path: '/repair' },
            ].map((item) => (
              <button key={item.path} onClick={() => go(item.path)} className="bg-gray-50 border border-gray-200 rounded-xl p-4 text-sm font-medium text-gray-700 hover:border-indigo-400 hover:text-indigo-700 hover:bg-indigo-50 transition-colors text-center">
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-3">MacBook Reparatur aus München anfragen</h2>
          <p className="text-gray-400 mb-8">Kostenloser Versand · 12 Monate Garantie · Kostenvoranschlag vor Reparaturbeginn</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="mailto:service@phone-medic.de" className="bg-indigo-600 text-white px-7 py-3.5 rounded-lg font-semibold hover:bg-indigo-700 transition-colors">
              Per E-Mail anfragen
            </a>
            <a href="https://wa.me/491605010907" target="_blank" rel="noopener noreferrer" className="bg-white text-gray-900 px-7 py-3.5 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
              WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default MacBookMuenchenPage
